import * as React from "react";
import { Link } from "react-router-dom";
import { Box, Container, Grid, Typography, useTheme, useMediaQuery } from "@mui/material";
import PrefeituraLogo from "~/images/illustrations/logo-prefeitura-do-recife.svg";
import { APP_ROUTES } from "~/single-page/constants/routes";

const FooterLink = ({ to, children }) => {
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  
  return (
    <Typography
      variant="body1"
      component={Link}
      to={to}
      sx={{
        color: 'white',
        textDecoration: 'none',
        display: 'block',
        mb: 1.5,
        transition: 'opacity 0.2s ease',
        textAlign: isMobile ? 'center' : 'left',
        '&:hover': {
          opacity: 0.8
        }
      }}
    >
      {children}
    </Typography>
  );
};

const MENU_ITEMS = [
  { title: 'Voluntariado e doação', path: APP_ROUTES.ROOT },
  { title: 'Doação de Sangue', path: APP_ROUTES.BLOOD_DONATIONS },
  { title: 'Imposto de Renda', path: APP_ROUTES.INCOME_TAX },
  { title: 'Área da ONG', path: APP_ROUTES.NGOS },
  { title: 'Agenda de eventos', path: APP_ROUTES.EVENTS },
  { title: 'Política de Privacidade', path: APP_ROUTES.PRIVACY_POLICY }
];

export default function Footer() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box
      component="footer"
      sx={{
        width: "100%",
        backgroundColor: "#009FE3",
        py: { xs: 4, md: 6 },
        mt: 'auto',
        position: 'relative',
        overflow: 'hidden'
      }}
    >
      <Container maxWidth="lg">
        <Grid 
          container 
          spacing={{ xs: 4, md: 8 }}
          sx={{ 
            px: { xs: 2, sm: 3, md: 4 }
          }}
        >
          {/* Logo e Descrição */}
          <Grid 
            item 
            xs={12} 
            md={4}
            sx={{
              textAlign: isMobile ? 'center' : 'left',
              display: 'flex',
              flexDirection: 'column',
              alignItems: isMobile ? 'center' : 'flex-start'
            }}
          >
            <Box 
              sx={{ 
                mb: { xs: 2, md: 4 },
                display: 'flex',
                justifyContent: isMobile ? 'center' : 'flex-start',
                width: '100%'
              }}
            >
              <Link to={APP_ROUTES.ROOT}>
                <img 
                  src={PrefeituraLogo} 
                  alt="Logo da Prefeitura do Recife"
                  style={{
                    maxWidth: '100%',
                    height: 'auto',
                    marginBottom: '24px'
                  }}
                />
              </Link>
            </Box>
            
            <Typography 
              variant={isMobile ? "h6" : "h5"} 
              fontWeight="bold" 
              color="white"
              sx={{ 
                mb: 1,
                mt: '-28px ',
                textAlign: isMobile ? 'center' : 'left'
              }}
            >
              Bora Impactar
            </Typography>
            
            <Typography 
              variant="body1" 
              color="white"
              sx={{ 
                opacity: 0.9,
                textAlign: isMobile ? 'center' : 'left'
              }}
            >
              A união que transforma vidas
            </Typography>

            {/* Link do Instagram */}
            <Box 
              sx={{ 
                display: 'flex',
                alignItems: 'center',
                justifyContent: isMobile ? 'center' : 'flex-start'
              }}
            >
              <a 
                href="https://www.instagram.com/boraimpactarrecife/" 
                target="_blank" 
                rel="noopener noreferrer"
                style={{
                  color: 'white',
                  display: 'flex',
                  alignItems: 'center',
                  textDecoration: 'none',
                  transition: 'opacity 0.2s',
                  marginTop: '26px'
                }}
                onMouseOver={(e) => e.currentTarget.style.opacity = 0.8}
                onMouseOut={(e) => e.currentTarget.style.opacity = 1}
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="white" style={{marginRight: '8px'}}>
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                </svg>
                <Typography variant="body2" color="white">
                  @boraimpactarrecife
                </Typography>
              </a>
            </Box>
          </Grid>

          {/* Menu Links */}
          <Grid 
            item 
            xs={12} 
            md={4}
            sx={{
              textAlign: isMobile ? 'center' : 'left'
            }}
          >
            <Typography 
              variant="h6" 
              color="white" 
              fontWeight="bold" 
              sx={{ 
                mb: { xs: 2, md: 4 },
                textAlign: isMobile ? 'center' : 'left'
              }}
            >
              Portal
            </Typography>

            <Box 
              sx={{ 
                display: 'flex', 
                flexDirection: 'column',
                alignItems: isMobile ? 'center' : 'flex-start'
              }}
            >
              {MENU_ITEMS.map((item, index) => (
                <FooterLink 
                  key={`footer-link-${index}`} 
                  to={item.path}
                >
                  {item.title}
                </FooterLink>
              ))}
            </Box>
          </Grid>

          {/* Imagem Bora Impactar */}
          <Grid 
            item 
            xs={12} 
            md={4}
            sx={{
              display: 'flex',
              justifyContent: isMobile ? 'center' : 'flex-end',
              alignItems: 'flex-start',
              paddingTop: { md: '0'}
            }}
          >
            <Box
              sx={{
                display: { xs: 'none', md: 'block' },
                maxWidth: '200px',
                width: '100%',
                textAlign: 'right',
                paddingRight: { md: '0'},
                marginTop: { md: '10px'}
              }}
            >
              <img 
                src="/images/bora_impactar_footer.png"
                alt="Bora Impactar - Ilustração"
                style={{
                  width: '70%',
                  height: 'auto',
                  maxWidth: '200px',
                  objectFit: 'contain'
                }}
              />
            </Box>
          </Grid>
        </Grid>

        {/* Copyright */}
        <Box 
          sx={{ 
            mt: { xs: 4, md: 6 },
            pt: 3,
            borderTop: '1px solid rgba(255, 255, 255, 0.1)',
            textAlign: 'center'
          }}
        >
          <Typography 
            variant="body2" 
            color="white" 
            sx={{ opacity: 0.7 }}
          >
            © {new Date().getFullYear()} Prefeitura do Recife. Todos os direitos reservados.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}